import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/** ![searchIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48Y2lyY2xlIGN4PSIxMSIgY3k9IjExIiByPSI4Ii8+PHBhdGggZD0ibTIxIDIxLTQuMy00LjMiLz48L3N2Zz4=) */
const searchIcon = /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx("circle", {
    cx: 11,
    cy: 11,
    r: 8
  }), /*#__PURE__*/jsx("path", {
    d: "m21 21-4.3-4.3"
  })]
});

export { searchIcon };
